module.exports = "/_next/static/images/phone-frame-2440ee559c55aa7463121f0904c280db.png";